import React from 'react';

import {
  MotifSortieDto,
  MotifSortieViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';
import { MotifSortieFormValues } from 'types/referentiels/MotifSortie';

import { buildRequestDto } from '../utils';

import { ModalEditionMotifSortie } from './ModalEditionMotifSortie';

interface ModalCreateProps {
  motifSortie: MotifSortieDto;
  visible: boolean;
  close: () => void;
  refreshDashboard: () => void;
}

function ModalCreate({
  motifSortie,
  visible,
  close,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: MotifSortieFormValues = {
    ...motifSortie,
    delaiEffacement: motifSortie.delaiEffacementEnMois,
  };
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: MotifSortieFormValues) =>
      AdminFonctionnelControllerApi.updateMotifSortieUsingPUT(
        motifSortie.idCorrelation,
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (
      field: MotifSortieViolationDtoFormFieldEnum,
      values: MotifSortieFormValues,
    ) =>
      AdminFonctionnelControllerApi.validateUpdateMotifSortieFieldUsingPUT(
        field,
        motifSortie.idCorrelation,
        buildRequestDto(values),
      ),
    response => response.motifSortieViolationsDto ?? [],
  );

  return (
    <ModalEditionMotifSortie
      close={close}
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      visible={visible}
      title={'Mise à jour du motif de sortie'}
      validate={validate}
    />
  );
}

export default ModalCreate;
